<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <h2 class="pageHeading">USER DETAILS</h2>
          
          <b-row>
            <b-col md="9" class="mt-3">
              <div class="d-flex justify-content-between mb-2">
                <div class="d-flex justify-content-start w-50 px-2 align-items-center">
                  <p class="headBase">User Name:</p>
                  <p class="subHeadBase">{{ userData.userview }}</p>
                </div>
                <div class="d-flex justify-content-start w-50 px-2 align-items-center">
                  <p class="headBase">Email:</p>
                  <p class="subHeadBase">{{ userData.email }}</p>
                </div>
              </div>

              <div class="d-flex justify-content-between mb-2">
                <div class="d-flex justify-content-start w-50 px-2 align-items-center">
                  <p class="headBase">Daily Request:</p>
                  <p class="subHeadBase">{{ userData.daily_request }}</p>
                </div>
                <div class="d-flex justify-content-start w-50 px-2 align-items-center">
                  <p class="headBase">Joining Date:</p>
                  <p class="subHeadBase">{{ userData.joining_date }}</p>
                </div>
              </div>

              <div class="d-flex justify-content-between mb-2">
                <div class="d-flex justify-content-start w-50 px-2 align-items-center">
                  <p class="headBase">Last Request Time:</p>
                  <p class="subHeadBase">{{ userData.last_hit }}</p>
                </div>
                <div class="d-flex justify-content-start w-50 px-2 align-items-center">
                  <p class="headBase">User Type:</p>
                  <b-form-select
                    :value="userData.user_type"
                    :options="userTypeOptions"
                    size="sm"
                    class="user-type-select"
                    @change="promptUserTypeUpdate"
                  ></b-form-select>
                </div>
              </div>
            </b-col>
          </b-row>

          <b-row class="mt-4">
            <b-col md="6">
              <b-card class="bg-blue2 d-flex align-items-center justify-content-start px-3">
                <p class="headDetails2" v-if="this.clienttoken == '' && ClientTokenCheck" ref="generatedtoken">
                  {{ userData.token }}
                </p>
                <p class="headDetails2" v-else-if="ClientTokenCheck" ref="generatedtoken">
                  {{ this.clienttoken }}
                </p>
                <p class="headDetails2" v-else>Token Copied...</p>
              </b-card>
            </b-col>
            <b-col md="6" class="d-flex align-items-center">
              <b-button variant="primary" class="mx-1" @click="showModal">Generate Token</b-button>
              <b-button variant="primary" class="mx-1" @click="copyToClipboard">Copy Token</b-button>
              <b-button variant="outline-primary" class="mx-1" @click="openApiAccessModal">API Access</b-button>
            </b-col>
          </b-row>

          <b-row class="mt-5">
            <b-col md="12">
              <h4 class="pageHeading">IP Restrictions</h4>
              <b-card class="border-light shadow-sm">
                <b-form-input
                  v-model="ipFilter"
                  placeholder="Search IP..."
                  class="mb-3"
                ></b-form-input>

                <div v-if="filteredIPs.length > 0">
                  <ul class="list-group list-container">
                    <li
                      v-for="(ip, index) in filteredIPs"
                      :key="index"
                      class="list-group-item d-flex justify-content-between align-items-center"
                    >
                      <span class="ip-text">{{ ip }}</span>
                      <div>
                        <b-button size="sm" variant="warning" class="mx-1 text-white" @click="openUpdateModal(ip)">Update</b-button>
                        <b-button size="sm" variant="danger" class="mx-1" @click="removeIP(ip)">Remove</b-button>
                      </div>
                    </li>
                  </ul>
                </div>
                <div v-else class="text-center py-3">
                  <p class="text-muted">No IP Restrictions applied.</p>
                </div>
                <b-button variant="primary" class="mt-3" @click="openAddModal">Add New IP</b-button>
              </b-card>
            </b-col>
          </b-row>

          <b-row class="mt-4">
            <b-col md="12">
              <b-button class="btn-previous" variant="light" :to="{name: 'setting'}">Previous Page</b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="type-confirm-modal" hide-footer title="Confirm Change">
      <div class="d-block text-center py-3">
        <h6>Are you sure you want to update user to <b>{{ pendingUserType }}</b>?</h6>
      </div>
      <div class="d-flex justify-content-end">
        <b-button class="mx-2" variant="outline-danger" @click="cancelTypeUpdate">No</b-button>
        <b-button class="mx-2" variant="primary" @click="confirmUserTypeUpdate">Yes</b-button>
      </div>
    </b-modal>

    <b-modal ref="my-modal" hide-footer title="Generate New Token">
      <div class="d-block text-center py-3">
        <h6>Are you sure you want to generate a new <b>TOKEN KEY</b>?</h6>
      </div>
      <div class="d-flex justify-content-end">
        <b-button class="mx-2" variant="outline-secondary" @click="hideModal">Close</b-button>
        <b-button class="mx-2" variant="primary" @click="generateToken">Generate Token</b-button>
      </div>
    </b-modal>

    <b-modal ref="ip-modal" hide-footer :title="ipMode == 'add' ? 'Add IP Address' : 'Update IP Address'">
      <b-form-input v-model="ipInput" placeholder="Enter IP Address"></b-form-input>
      <div class="d-flex justify-content-end mt-3">
        <b-button class="mx-2" variant="outline-secondary" @click="closeIPModal">Cancel</b-button>
        <b-button class="mx-2" variant="primary" @click="submitIP">Submit</b-button>
      </div>
    </b-modal>

    <b-modal ref="api-access-modal" hide-footer title="Manage API Access Permutations">
      <div class="py-2 px-1">
        <p class="mb-3 text-secondary font-weight-bold" style="font-size: 15px;">Select Permitted Operations:</p>
        
        <div v-if="apiAccessOptions.length === 0" class="text-center py-3 text-muted">
          Loading permitted backend operations...
        </div>

        <div v-else class="checkbox-container">
          <div 
            v-for="option in apiAccessOptions" 
            :key="option.value" 
            class="d-flex align-items-center mb-3 custom-checkbox-wrapper"
          >
            <b-form-checkbox
              :id="'chk-' + option.value"
              v-model="selectedApiAccess"
              :value="option.value"
              class="m-0 p-0 d-flex align-items-center"
            >
              <span class="ml-2 checkbox-label-text">{{ option.text }}</span>
            </b-form-checkbox>
          </div>
        </div>
      </div>
      
      <div class="d-flex justify-content-end mt-3 pt-3 border-top">
        <b-button class="mx-2 px-4" variant="outline-secondary" @click="closeApiAccessModal">Cancel</b-button>
        <b-button 
          class="mx-1 px-4" 
          variant="primary" 
          :disabled="apiAccessOptions.length === 0" 
          @click="saveApiAccess"
        >
          Save Changes
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from '@axios'
import { BRow, BCol, BCard, BButton, BFormInput, BFormSelect, BModal, BFormCheckbox } from 'bootstrap-vue'

export default {
  components: { BRow, BCol, BCard, BButton, BFormInput, BFormSelect, BModal, BFormCheckbox },

  data() {
    return {
      userData: {
        userview: '',
        email: '',
        daily_request: 'None',
        joining_date: '',
        last_hit: '',
        token: '',
        user_type: 'external',
        ip_addresses: [],
        api_access: []
      },
      pendingUserType: '', 
      userTypeOptions: [
        { value: 'internal', text: 'Internal' },
        { value: 'external', text: 'External' }
      ],
      clienttoken: '',
      ClientTokenCheck: true,
      ipInput: "",
      ipMode: "add",
      updateOldIP: "",
      ipFilter: "",
      
      selectedApiAccess: [], 
      apiAccessOptions: []   
    }
  },

  computed: {
    filteredIPs() {
      if (!this.ipFilter) return this.userData.ip_addresses
      return this.userData.ip_addresses.filter(ip =>
        ip.toLowerCase().includes(this.ipFilter.toLowerCase())
      )
    }
  },

  methods: {
    // USER TYPE LOGIC
    promptUserTypeUpdate(newVal) {
      this.pendingUserType = newVal;
      this.$refs['type-confirm-modal'].show();
    },
    cancelTypeUpdate() {
      this.pendingUserType = '';
      this.$refs['type-confirm-modal'].hide();
    },
    async confirmUserTypeUpdate() {
      try {
        await axios.post('update_usertype', { 
            username: this.$route.params.user,
            user: this.$route.params.user, 
            type: this.pendingUserType 
        });
        this.userData.user_type = this.pendingUserType;
        this.$refs['type-confirm-modal'].hide();
      } catch (err) {
        alert("Failed to update user type");
      }
    },

    // TOKEN LOGIC
    showModal() { this.$refs['my-modal'].show() },
    hideModal() { this.$refs['my-modal'].hide() },
    
    copyToClipboard() {
      this.ClientTokenCheck = false;
      const paragraphElement = this.$refs.generatedtoken;
      const range = document.createRange();
      range.selectNode(paragraphElement);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand('copy');
      selection.removeAllRanges();
      setTimeout(() => { this.ClientTokenCheck = true; }, 2000);
    },

    async generateToken() {
      try {
        const res = await axios.post('clienttoken', { username: this.$route.params.user })
        this.clienttoken = res.data.token
        this.hideModal()
      } catch (err) {
        alert("Error generating token")
      }
    },

    // IP LOGIC
    openAddModal() { this.ipMode = "add"; this.ipInput = ""; this.$refs["ip-modal"].show(); },
    openUpdateModal(ip) { this.ipMode = "update"; this.updateOldIP = ip; this.ipInput = ip; this.$refs["ip-modal"].show(); },
    closeIPModal() { this.$refs["ip-modal"].hide() },

    async submitIP() {
      if (!this.ipInput) return alert("Enter IP")
      const ipList = this.ipInput.split(",").map(ip => ip.trim()).filter(ip => ip.length > 0);
      try {
        if (this.ipMode === "add") {
          await axios.post("add-ip", { username: this.$route.params.user, ip: ipList.join(",") })
          this.userData.ip_addresses.push(...ipList)
        } else {
          const newIP = ipList[0]
          await axios.post("update-ip", { username: this.$route.params.user, old_ip: this.updateOldIP, new_ip: newIP })
          const i = this.userData.ip_addresses.indexOf(this.updateOldIP)
          if (i !== -1) this.userData.ip_addresses.splice(i, 1, newIP)
        }
        this.closeIPModal()
      } catch (err) { alert("Failed to update IP") }
    },

    async removeIP(ip) {
      try {
        await axios.post("remove-ip", { username: this.$route.params.user, ip: ip })
        const i = this.userData.ip_addresses.indexOf(ip)
        if (i !== -1) this.userData.ip_addresses.splice(i, 1)
      } catch (err) { alert("Failed to remove IP") }
    },
    // DYNAMIC API ACCESS LOGIC
async openApiAccessModal() {
  try {
    // 1. Fetch available operations passing username via a POST payload body
    const res = await axios.post('api_access', {
      username: this.$route.params.user
    });

    const checkedStrings = res.data.checked || [];
    const uncheckedStrings = res.data.unchecked || [];
    
    // Combine both arrays to know everything available from the backend
    const allAvailableStrings = [...checkedStrings, ...uncheckedStrings];

    // Define your grouping rules here
    const groupMapping = {
      hoteldescription: 'hoteldetails',
      hotelshortdescription: 'hoteldetails'
    };

    // Define clean UI text labels for grouped keys or standard keys
    const uiLabels = {
      hoteldetails: 'Hotel Details',
      roommapping: 'Room Mapping',
      suppliersdata: 'Destination Mapping'
    };

    // Helper utility function to turn a slug into a clean title
    const formatLabel = slug => {
      return uiLabels[slug] || (slug.charAt(0).toUpperCase() + slug.slice(1));
    };

    // 2. Build unique checkbox options based on groups
    const distinctKeys = new Set();
    allAvailableStrings.forEach(item => {
      const parentKey = groupMapping[item] || item;
      distinctKeys.add(parentKey);
    });

    // 3. Map distinct keys into the checkbox structure { text, value }
    this.apiAccessOptions = Array.from(distinctKeys).map(key => ({
      text: formatLabel(key),
      value: key
    }));

    // 4. Determine what should be visually "checked" in the UI.
    // For grouped items (like hoteldetails), it should be checked ONLY if ALL underlying items are checked.
    const uiSelected = [];
    
    if (checkedStrings.includes('hoteldescription') && checkedStrings.includes('hotelshortdescription')) {
      uiSelected.push('hoteldetails');
    }
    
    // Add other non-grouped items if they were checked by the backend
    if (checkedStrings.includes('roommapping')) uiSelected.push('roommapping');
    if (checkedStrings.includes('suppliersdata')) uiSelected.push('suppliersdata');

    this.selectedApiAccess = uiSelected;
    
    // 5. Store the real backend string values inside your core data object
    this.userData.api_access = [...checkedStrings];
    this.$refs['api-access-modal'].show();

  } catch (err) {
    alert("Failed to load available API operations list configurations.");
    console.error(err);
  }
},

closeApiAccessModal() {
  this.$refs['api-access-modal'].hide();
},

async saveApiAccess() {
  try {
    // Reconstruct the flat array required by your backend based on what is selected in the UI
    const flatAccessPayload = [];

    // If 'hoteldetails' checkbox is checked, push BOTH raw strings into the array together
    if (this.selectedApiAccess.includes('hoteldetails')) {
      flatAccessPayload.push('hoteldescription', 'hotelshortdescription');
    }
    
    if (this.selectedApiAccess.includes('roommapping')) {
      flatAccessPayload.push('roommapping');
    }
    
    if (this.selectedApiAccess.includes('suppliersdata')) {
      flatAccessPayload.push('suppliersdata');
    }

    // Pass the mapped array directly over to your backend endpoint
    await axios.post('update_api_access', {
      username: this.$route.params.user,
      access: flatAccessPayload
    });
    
    // Sync UI components state and terminate modal layout
    this.userData.api_access = [...flatAccessPayload];
    this.closeApiAccessModal();
    // alert("API access configurations updated successfully!");
  } catch (err) {
    alert("Failed to update API access layout configuration.");
    console.error(err);
  }
}
  },

  async mounted() {
    try {
      const [r1, r2] = await Promise.all([
        axios.post('userinfo', { username: this.$route.params.user }),
        axios.post('userinfo1', { username: this.$route.params.user })
      ])
      this.userData = {
        email: r2.data.Email,
        token: r2.data.Token,
        userview: r1.data.User,
        daily_request: r1.data.daily_request || 'None',
        joining_date: r2.data.joining_date,
        last_hit: r2.data.last_hit,
        user_type: r1.data.user_type || 'external',
        ip_addresses: r1.data.ip_addresses || [],
        api_access: r1.data.api_access || []
      }
    } catch (err) { console.error(err) }
  }
}
</script>

<style scoped>
.pageHeading { font-weight: 700; color: #333; margin-bottom: 20px; text-transform: uppercase; }
.headBase { font-weight: 600; color: #666; min-width: 150px; margin-bottom: 0; }
.subHeadBase { font-weight: 700; color: #000; margin-bottom: 0; }
.user-type-select { width: 160px; border-radius: 6px; border: 1px solid #ced4da; }
.bg-blue2 { background-color: #eef6ff !important; border: 1px solid #c2dbff; height: 55px !important; border-radius: 8px; }
.headDetails2 { font-size: 16px; font-family: 'Courier New', Courier, monospace; font-weight: 600; color: #2c3e50; margin-bottom: 0; word-break: break-all; }
.list-container { max-height: 250px; overflow-y: auto; border: 1px solid #eee; border-radius: 8px; }
.ip-text { font-weight: 500; color: #444; }
.btn-previous { margin-top: 30px; width: 180px; height: 45px; font-weight: 600; border: 1px solid #ddd; }

/* CHECKBOX ALIGNMENT STYLES */
.checkbox-container {
  padding-left: 2px;
}
.custom-checkbox-wrapper {
  min-height: 24px;
}
::v-deep .custom-control-label {
  display: inline-flex !important;
  align-items: center !important;
  padding-left: 10px !important;
  cursor: pointer;
}
::v-deep .custom-control-input {
  cursor: pointer;
}
.checkbox-label-text {
  font-size: 15px;
  color: #333333;
  font-weight: 500;
}
</style>
